import React from 'react';
import { Redirect } from 'react-router-dom';
import { ToccaUtils } from 'modules/utils';

import { WelcomeMobileConfig } from 'pages/Event/WelcomeConfig';
import { LobbyMobileConfig } from 'pages/Lobby/LobbyConfig';
import { NetworkingConfig } from 'pages/Networking/NetworkingConfig';
import { SponsorConfig } from 'pages/Sponsor/SponsorConfig';
import { SponsorListConfig } from 'pages/SponsorList/SponsorListConfig';
import { BreakoutMobileConfig } from 'pages/Breakout/BreakoutConfig';
import { SponsorBreakoutMobileConfig } from 'pages/SponsorBreakout/SponsorBreakoutConfig';
import { NotFoundConfig } from 'pages/NotFound/NotFoundConfig';
import { BreakoutGroupConfig } from 'pages/BreakoutGroup/BreakoutGroupConfig';
import { DiscoveryMobileConfig } from 'pages/Discovery/DiscoveryConfig';
import { EventLandingMobileConfig } from 'pages/EventLanding/EventLandingConfig';

const routeConfigs = [
    DiscoveryMobileConfig,
    LobbyMobileConfig,
    WelcomeMobileConfig,
    NetworkingConfig,
    SponsorConfig,
    SponsorListConfig,
    BreakoutMobileConfig,
    SponsorBreakoutMobileConfig,
    NotFoundConfig,
    BreakoutGroupConfig,
    EventLandingMobileConfig
];

const routes = [
    ...ToccaUtils.generateRoutesFromConfigs(routeConfigs),
    {
        path: '/',
        exact: true,
        isPrivate: true,
        component: () => <Redirect to="/lobby" />,
    },
    // {
    //     path: '*',
    //     exact: true,
    //     isPrivate: true,
    //     component: () => <Redirect to="/not-found" />,
    // },
];

export default routes;
